import styled, { css } from 'styled-components';
import { TInput } from './input.types';

export const InputStyled = styled.div<TInput>`
    ${({ theme }) => theme.mixins.gridColumnCenter};
    ${({ theme }) => theme.typography.input_1};
    grid-auto-columns: 1fr;
    background-color: ${({ theme }) => theme.branding.white.lighter};
    border: 1px solid ${({ theme }) => theme.branding.gray.light};
    color: ${({ theme }) => theme.branding.text.main};
    border-radius: ${({ theme }) => theme.defaults.borderRadius};
    width: ${({ width }) => width ? width : '100%'};
    padding: 0 15px;
    width: 100%;
    height: 35px;
    transition: 150ms all;
    grid-area: input;

    input {
        border: none;
        width: 100%;
    }

    &:hover {
        border-color: ${({ theme }) => theme.branding.primary.light};
    }

    ${({ isLoading }) =>
        isLoading &&
        css`
            grid-auto-columns: 1fr max-content;
        `}

    ${({ shrink }) =>
        shrink &&
        css`
            width: max-content;
        `}

    ${({ active, theme }) =>
      active &&
      css`
        &:hover,
          & {
            border-color: ${theme.branding.primary.main};
          }
    `}
    
    ${({ isError, theme }) =>
      isError &&
      css`
        & {
          border-color: ${theme.branding.tertiary.main};
        }
        &:hover {
          border-color: ${theme.branding.tertiary.light};
        }
      `
    }

    ${({ hasBtnCount }) =>
      hasBtnCount &&
        css`
          padding-right: ${hasBtnCount * 28}px;
        `
    }
`;

export const AdornmentWrapper = styled.span<{
    before?: boolean;
    after?: boolean;
}>`
    display: grid;
    grid-auto-flow: column;
    width: 100%;
    gap: 0.5rem;
    grid-auto-columns: ${({ before, after }) =>
        `${before ? 'max-content' : ''} 1fr ${after ? 'max-content' : ''} `};

    & > span {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
